import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "choose-user-login-mobile" }
const _hoisted_2 = { class: "user-identity-list" }

import { ref, computed, watch } from "vue";
import { MessageAlert } from "@/composables/useMessageAlert";
import { UserRole } from "@/constant";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserIdentifyLoginMobile',
  props: {
    curRoleType: {
        type: String,
        default: () => {
            return "";
        },
    },
},
  emits: ["onNext"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emits = __emit;

const curChooseCareerSelected = ref<number>(0);
const isDisabledChooseCareerSelected = computed(() => {
    return curChooseCareerSelected.value ? false : true;
});

watch(
    () => props.curRoleType,
    (newV) => {
        curChooseCareerSelected.value =
            newV === UserRole.User.toUpperCase()
                ? 1
                : newV === UserRole.Doctor.toUpperCase()
                ? 2
                : 0;
    },
    { immediate: true }
);

// 注册-选择完职业之后点击next按钮
const _handleChooseCareerNext = () => {
    if (isDisabledChooseCareerSelected.value) {
        MessageAlert("Please choose a User identity");
        return;
    }
    emits("onNext", curChooseCareerSelected.value);
};

const _hdanleChooseCareerSelected = (type: number) => {
    curChooseCareerSelected.value = type;
    _handleChooseCareerNext();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["user-identity-item user-member", { selected: curChooseCareerSelected.value === 1 }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_hdanleChooseCareerSelected(1)))
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("div", { class: "user-identity-item-name" }, "Member", -1)
      ]), 2),
      _createElementVNode("div", {
        class: _normalizeClass(["user-identity-item user-doctor", { selected: curChooseCareerSelected.value === 2 }]),
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_hdanleChooseCareerSelected(2)), ["stop"]))
      }, _cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "user-identity-item-name" }, "Doctor", -1)
      ]), 2)
    ])
  ]))
}
}

})